
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 0c2.171 0 3.938 1.949 3.938 4.345S15.67 8.69 13.5 8.69c-2.171 0-3.938-1.95-3.938-4.345C9.563 1.949 11.33 0 13.5 0zM5.625 3.103c.63 0 1.215.187 1.721.522C7.178 5.4 7.65 7.163 8.617 8.54c-.562 1.191-1.687 2.01-2.992 2.01-1.868 0-3.375-1.663-3.375-3.723 0-2.061 1.507-3.725 3.375-3.725zm15.75 0c1.867 0 3.375 1.664 3.375 3.725 0 2.06-1.508 3.724-3.375 3.724-1.305 0-2.43-.82-2.992-2.011.967-1.378 1.44-3.141 1.27-4.916a3.09 3.09 0 011.722-.522zM6.187 15.828c0-2.57 3.274-4.656 7.313-4.656s7.313 2.086 7.313 4.656V18H6.188v-2.172zM0 18v-1.862c0-1.726 2.126-3.178 5.006-3.6-.663.844-1.069 2.011-1.069 3.29V18H0zm27 0h-3.938v-2.172c0-1.279-.405-2.446-1.068-3.29 2.88.422 5.006 1.874 5.006 3.6V18z","fill":"#0277BD"}})])
          )
        }
      }
    